import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface EditProfileResponse extends APIResponse
{

}

export class EditProfileResponseDtoImpl extends APIResponseDtoImpl implements EditProfileResponse
{
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/editprofile/editprofileresponse.tsx